module.exports = __webpack_public_path__ + "static/FARM-e88626a285a97579d33c422ca275ce3e.svg";